import { classNames } from '../utilities';

export const SendIntakeIcon = ({ fill = '', className, onClick }) => {
  return (
    <svg
      className={classNames('', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 10.6909L12 10.1909V9C11.9988 8.29169 11.7473 7.6066 11.2898 7.06585C10.8323 6.52509 10.1983 6.1635 9.5 6.045V5H8.5V6.045C7.80167 6.1635 7.16772 6.52509 6.71023 7.06585C6.25274 7.6066 6.00118 8.29169 6 9V10.1909L5 10.6909V13H8V14H10V13H13V10.6909ZM12 12H6V11.3091L7 10.8091V9C7 8.46957 7.21071 7.96086 7.58579 7.58579C7.96086 7.21071 8.46957 7 9 7C9.53043 7 10.0391 7.21071 10.4142 7.58579C10.7893 7.96086 11 8.46957 11 9V10.8091L12 11.3091V12Z"
        fill="#666666"
      />
      <path
        d="M12 2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H9V0H8V1H4V0H3V1H1C0.734784 1 0.48043 1.10536 0.292893 1.29289C0.105357 1.48043 0 1.73478 0 2V12C0 12.2652 0.105357 12.5196 0.292893 12.7071C0.48043 12.8946 0.734784 13 1 13H3V12H1V2H3V3H4V2H8V3H9V2H11V5H12V2Z"
        fill="#666666"
      />
    </svg>
  );
};
